const releaseNotesBaseUrl = 'app/release-notes';

export const releaseNotesPath = `${releaseNotesBaseUrl}`;
export const getReleasesNotesByAppVersion = (appVersion: string, status: 'active' | 'all') => (
  `${releaseNotesBaseUrl}?v=${appVersion}&status=${status}`
);
export const singleReleaseNotesIdPath = (id: number) => `${releaseNotesBaseUrl}/${id}`;
